import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { LogApiResponse, logApiResponseSchema } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';

export type LogType = 'AccessLog' | 'EventLog' | 'GroupLog' | 'UserLog' | 'NotificationLog';

export const getLogs = async (params?: {
	type?: LogType;
	from?: string;
	until?: string;
	page?: number;
	sort?: string;
}): Promise<LogApiResponse> => {
	const query = constructQuery({
		type: params?.type || 'AccessLog',
		from: params?.from,
		until: params?.until,
		page: params?.page,
		sort: params?.sort || 'timestamp:desc',
	});
	const { body } = await clientRequest.get(`/api/logs/type?${query}`, {
		schema: logApiResponseSchema,
	});
	return body;
};

export const getGroupLogs = async (
	groupId: string,
	params?: { from?: string; until?: string; page?: number; sort?: string },
): Promise<LogApiResponse> => {
	const query = constructQuery({
		type: 'GroupLog',
		groupId,
		from: params?.from,
		until: params?.until,
		page: params?.page,
		sort: params?.sort || 'timestamp:desc',
	});
	const { body } = await clientRequest.get(`/api/logs/type?${query}`, {
		schema: logApiResponseSchema,
	});
	return body;
};

export const getUserLogs = async (
	userId: string,
	params?: { from?: string; until?: string; page?: number; sort?: string; type?: string },
): Promise<LogApiResponse> => {
	const query = constructQuery({
		type: params?.type || 'UserLog',
		userId,
		from: params?.from,
		until: params?.until,
		page: params?.page,
		sort: params?.sort || 'timestamp:desc',
	});
	const { body } = await clientRequest.get(`/api/logs/type?${query}`, {
		schema: logApiResponseSchema,
	});
	return body;
};
